import { Td } from '@chakra-ui/react';

const QuotedBy = ({ printer }) => {
  return <Td>{printer || 'Not Available'}</Td>;
};
export default QuotedBy;
